var infScroll = new InfiniteScroll( 'section.grid', { // 記事を挿入していく要素を指定
    append: '.post',             // 各記事の要素
    path: '.next.page-numbers',  // 次のページへのリンク要素を指定
    hideNav: '.pagination_wrapper', // 指定要素を非表示にする（ここは無くてもOK）
    button: '.view-more-button', // 記事を読み込むトリガーとなる要素を指定
    scrollThreshold: 400,      // スクロールで読み込む：falseで機能停止（デフォルトはtrue）
    status: '.page-load-status', // ステータス部分の要素を指定
    history: 'false'             // falseで履歴に残さない
});

// フォームからの値でページ遷移する
function changeDisplay() {
	// フォームエレメントを取得
	obj = document.changedisplaynum.linkselect;
	// 選択したエレメントの値を取得（今回はURL）
	index = obj.selectedIndex;
	href = obj.options[ index ].value;
	// パラメーター付きのURLに遷移
	location.href = href;
}

( function ( $ ) {

	// Magnific Popup
	// start
	$( 'a[href$=jpg],a[href$=gif],a[href$=png]' ).magnificPopup( {
		type: 'image'
	} )
	$( '.open-popup-inline' ).magnificPopup( {
		type: 'inline',
		midClick: true
	} );
	$( '.open-popup-terms-stock' ).magnificPopup( {
		type: 'ajax',
		midClick: true,
		callbacks: {
			parseAjax: function ( mfpResponse ) {
				mfpResponse.data = $( mfpResponse.data ).find( '#terms-stock' ).addClass( 'white-popup' );
			}
		}
	} );
	$( '.open-popup-terms-delivery' ).magnificPopup( {
		type: 'ajax',
		midClick: true,
		callbacks: {
			parseAjax: function ( mfpResponse ) {
				mfpResponse.data = $( mfpResponse.data ).find( '#terms-delivery' ).addClass( 'white-popup' );
				console.log( 'ajax done' )
			}
		}
	} );
	$( '.open-popup-delivery' ).magnificPopup( {
		type: 'ajax',
		midClick: true,
		callbacks: {
			parseAjax: function ( mfpResponse ) {
				mfpResponse.data = $( mfpResponse.data ).find( 'article' ).addClass( 'white-popup wider' );
				console.log( 'ajax done' )
			}
		}
	} );
	// モーダルでフォーム動かない（もーだるい）
	// $( '.open-popup-contact' ).magnificPopup( {
	// 	type: 'ajax',
	// 	midClick: true,
	// 	callbacks: {
	// 		parseAjax: function ( mfpResponse ) {
	// 			mfpResponse.data = $( mfpResponse.data ).find( 'article' ).addClass( 'white-popup wider' );
	// 			console.log( 'ajax done' )
	// 		}
	// 	}
	// } );
	$( '.open-popup-buyer-guide' ).magnificPopup( {
		type: 'ajax',
		midClick: true,
		callbacks: {
			parseAjax: function ( mfpResponse ) {
				mfpResponse.data = $( mfpResponse.data ).find( 'article' ).addClass( 'white-popup wider' );
				console.log( 'ajax done' )
			}
		}
	} );
	$( '.open-popup-about' ).magnificPopup( {
		type: 'ajax',
		midClick: true,
		callbacks: {
			parseAjax: function ( mfpResponse ) {
				mfpResponse.data = $( mfpResponse.data ).find( 'article' ).addClass( 'white-popup wider' );
				console.log( 'ajax done' )
			}
		}
	} );
	$( '.open-popup-unit' ).magnificPopup( {
		type: 'ajax',
		midClick: true,
		callbacks: {
			parseAjax: function ( mfpResponse ) {
				mfpResponse.data = $( mfpResponse.data ).find( '#terms-unit' ).addClass( 'white-popup' );
				console.log( 'ajax done' )
			}
		}
	} );

	// Magnific Popup
	// end

	// 商品個別ページ画像下
	$( '.color-discrepancy' ).load( '/terms/ #terms-color' );

	// ２カラム時にcontentがasideより短い場合の
	// 右ボーダーがフッターに到達しない問題の対策
	// Start
	var mainHeight = $( '#main' ).outerHeight(),
		contentHeight = $( '#content' ).outerHeight(),
		asideHeight = $( '#secondary' ).outerHeight();

	console.log( 'mainHeight: ' + mainHeight );
	console.log( 'contHeight: ' + contentHeight );
	console.log( 'asideHeight: ' + asideHeight );

	function cHeight() {
		if ( $( '#main' ).hasClass( 'two-column' ) && asideHeight > contentHeight ) {
			$( '#content' ).css( 'minHeight', asideHeight )
		}
	}
	cHeight();
	var timer = false;
	$( window ).on( 'load resize', function () {
		if ( timer !== false ) {
			clearTimeout( timer );
		}
		timer = setTimeout( function () {
			console.log( 'resized' );
			if ( $( window ).width() < 1000 ) {
				$( '#content' ).css( 'minHeight', 'auto' )
			} else {
				cHeight();
			}
		}, 200 );
	} );
	// ２カラム時にcontentがasideより短い場合の
	// 右ボーダーがフッターに到達しない問題の対策
	// end

	// カラーグープタグの色名に沿って視覚化（色付け）
	// start
	$( '.item-tag a[rel=tag],.tagcloud a' ).each( function () {
		var colorName = $( this ).text().toLowerCase();
		var colorHex = color_convert.to_hex( colorName )
		console.log( colorHex );
		$( this ).css( 'background-color', colorHex );
		$( this ).attr( 'title', colorName );

		'white' === colorName && $( this ).addClass( 'white' );
		'black' === colorName && $( this ).css( 'background-color', 'black' ); // RGBとの差別化
		'no' === colorName && $( this ).addClass( 'no' );
		'cream' === colorName && $( this ).css( 'background-color', 'bisque' );
		'shiny' === colorName && $( this ).css( 'background-color', '#E6E6E6' );
		'gold metallic' === colorName && $( this ).css( 'background-color', '#ffd700' );

		if ( $( this ).css( 'background-color' ) === 'rgb(0, 0, 0)' ) {
			$( this ).hide()
		}
		if ( colorName === 'black' ) {
			$( this ).show()
		}
	} );
	// カラーグープタグの色名に沿って視覚化（色付け）
	// end

	// responsiveSlides.js
	// start
	$( '.rslides' ).responsiveSlides( {
		auto: true, // Boolean: Animate automatically, true or false
		speed: 500, // Integer: Speed of the transition, in milliseconds
		timeout: 6000, // Integer: Time between slide transitions, in milliseconds
		pager: false, // Boolean: Show pager, true or false
		nav: false, // Boolean: Show navigation, true or false
		random: false, // Boolean: Randomize the order of the slides, true or false
		pause: false, // Boolean: Pause on hover, true or false
		pauseControls: true, // Boolean: Pause when hovering controls, true or false
		prevText: "Previous", // String: Text for the "previous" button
		nextText: "Next", // String: Text for the "next" button
		maxwidth: "", // Integer: Max-width of the slideshow, in pixels
		navContainer: "", // Selector: Where controls should be appended to, default is after the 'ul'
		manualControls: "", // Selector: Declare custom pager navigation
		namespace: "rslides", // String: Change the default namespace used
		before: function () {}, // Function: Before callback
		after: function () {} // Function: After callback
	} )
	// responsiveSlides.js
	// end

	if ( $( '.uk-url' ).length ) {
		scrapeUK();
	}

	function scrapeUK() {
		// UKサイトをスクレイピングして在庫連動風にする（要xdomain.php）
		var uk = $( '.uk-url' ).attr( 'href' ).replace( /^https?:/, 'https:' );
		var url = wnm_custom.template_url + '/xdomain.php?url=' + uk;
		console.log( url );
		$.ajax( {
			type: 'GET',
			url: url,
			dataType: 'text',
			success: function ( res ) {
				var response = $( res );
				var availability = response.find( '.stock.in-stock' ).text();
				var inStock = response.find( '.stock.in-stock' ).text();
				// 数値のみ（小数点が消える）
				// var availabilityOnly = parseInt( inStock.replace( /[^0-9]/g, '' ) );
				// 小数点以下を切り捨てて返す
				var availabilityOnly = parseInt( inStock.replace( /^([1-9]\d*|0)(\.\d+)?$/g, '' ) );
				var catFabric = response.find( '.product_cat-fabric' ).length > 0;
				if ( availability ) {
					// 在庫がある
					$( '.stock a' ).text( 'あり' );
					if ( availabilityOnly ) {
						if ( catFabric ) {
							$( '.only-left' ).html( '( 残り約 ' + availabilityOnly + ' メートル )' )
						} else {
							$( '.only-left' ).html( '( 残り約 ' + availabilityOnly + ' 玉 [ 50g ] )' )
						}
					} else {
						// 在庫はあるが残数が不明なので問い合わせてほしい
						$( '.stock a' ).html( 'お問合せください' )
						// カラーオプションのセレクトを選択できなくする
						$( '.skuform select' ).find( 'option' ).each( function ( i ) {
							$( this ).attr( 'class', 'disabled' );
						} );
						var options_sel_idx = 0;
						$( '.skuform select' ).on( 'change', this, function ( event ) {
							if ( $( this.options[ this.selectedIndex ] ).hasClass( 'disabled' ) ) {
								alert( '在庫数が不明です。\nお問合せください' );
								this.selectedIndex = options_sel_idx;
							} else {
								options_sel_idx = this.selectedIndex;
							}
						} );
						$( '.field' ).after( '<div class="itemsoldout">現在お取り扱いできません</div>' );
						$( '.c-box' ).hide();
					}

					// ユーザーが入力した数量を取得
					userInpitSkuquantity( availabilityOnly );

					function userInpitSkuquantity( i ) {
						$( 'input.skuquantity' ).keyup( function () {
							inputQuant = $( this ).eq( 0 ).val();
							if ( isNaN( inputQuant ) ) {
								console.log( '整数以外入力可能できません' );
							} else {
								if ( i >= inputQuant ) {
									$( 'input.skubutton' ).prop( 'disabled', false );
								} else {
									alert( '在庫数を上回る数量は入力できません\n在庫ステータスをご確認ください' );
									$( 'input.skubutton' ).prop( 'disabled', true );
								}
							}
							return inputQuant;
						} )
					}
				} else {
					// 在庫がない
					$this_title = $( '.item_page_title' ).text();
					$this_url = $( location ).attr( 'href' );
					$( '.stock a' )
						.html( '<i class="fa fa-envelope" aria-hidden="true"></i> お問合せ下さい' )
						.attr( 'href', 'mailto:info@lintondirect.co.jp?subject=[ 在庫確認 ] ' + $this_title + '&body=LINTON JAPAN 御中%0D%0A%0D%0A下記商品の在庫確認を希望します。%0D%0A%0D%0A[ 商品名 ] ' + $this_title + '%0D%0A[ ページURL ] ' + $this_url + '%0D%0A%0D%0A※ 以下の項目を必ずご記入ください。%0D%0A[ 数量（用尺）] %0D%0A[ お名前 ] %0D%0A[ 郵便番号 ] %0D%0A[ ご住所 ] %0D%0A[ お電話 ] %0D%0A[ メールアドレス ] ' )
						.attr( 'title', 'この商品の在庫をお問合せください（ご利用のメールクライアントが起動します）' );
					// $( '.field' ).after( '<div class="itemsoldout">現在お取り扱いできません</div>' );
					// $( '.c-box' ).hide();
					$( 'input.skubutton' ).prop( 'disabled', true );
				}
				$( '.fabric-instock .checking-stock' ).hide(); // スピナー隠す
				$( '.fabric-instock p' ).show(); // ステータスを表示
				$( '.skubutton' ).css( 'pointer-events', 'auto' );
			}
		} );
	} // scrapeUK()

	// 数量フィールドは半角英数字のみ入力できるようにする
	$( 'input.skuquantity' ).attr( 'style', 'ime-mode:disabled' )

	if ( $( '.skuform' ).length > 1 ) {
		$( '.skuform:first-of-type' ).addClass( 'skuform-first' ).find( '.fabric-quant-select' ).remove();
		$( '.skuform:last-of-type' ).addClass( 'skuform-last' ).find( '.fabric-quant-input' ).remove();
	} else {
		$( '.fabric-quant-select' ).remove();
	}

	// Edgeのheight:autoバグ対策
	// 毎アクセスフレッシュな画像を読み込む？ということでしょうかね？
	// https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/7778808/
	if ( window.navigator.userAgent.indexOf( 'Edge' ) > -1 ) {
		$( 'img[srcset]' ).each( function () {
			$( this ).attr( 'src', $( this ).attr( 'src' ) + '?' + Math.random() );
		} );
	}

	function skuformLastDisable() {
		$( '.disabled_last_sku' ).find( '.skuform-last .skubutton' ).on( 'click', function () {
			alert( '各服地の最低購入単位は1mからです。\n「1m単位で購入」をカートに入れると\n10cm単位の追加が可能となります。' );
			return false;
		} )
	}
	skuformLastDisable();

} )( jQuery );
